export default {
	"fca1": "FCAアカウント",
	"fca1-m": "FCAアカウント",
	"fca2": "EBC Financial Group (UK) Ltdは、英国金融行動監視機構（FCA）によって認可および監督されている総合な金融証券会社であり、「Matched Principal Broker」として仲介業務を行い、すべての注文は直接リクイディティプロバイダーとマッチングされます。<br/>登録番号：927552<br/><br/>EBC Financial Group (UK) LtdでFCA口座を開設した場合、FSCS補償プランに基づいて最大85,000ポンドを請求する権利があります。",
	"fca3": "EUの金融商品市場指令（MiFID）とその改訂版であるMiFID IIでは、顧客の知識、経験、専門性のレベルに応じて「リテール投資家」と「プロ投資家」に分類しています。<br/><br/>FCAの規定により、EBC Financial Group (UK) LtdにてFCA口座を開設できるのはプロ投資家（特定投資家または適格機関投資家を含む）のみとなります。レバレッジは100倍でお客様の資金はバークレイズ銀行の弊社法人口座で分別管理されます。",
    "fca4":{
		"title":"プロ投資家は次の３つの基準のうち2つを満たす必要があります：",
		"title-m":"プロ投資家は次の３つの基準のうち2つを満たす必要があります：",
		"desc":"過去1年間において、四半期ごとの平均取引回数が10回以上あること。",
		"desc1":"現預金やその他の金融商品の合計額が50万ユーロ以上であること。",
		"desc2":"金融業界で1年以上の勤務経験があり、CFD（差金決済取引）や金融派生商品取引についての知識を有する者。"
	},
	"fca5":{
		"title":"FCA口座開設方法",
		"desc":"申込書をダウンロードし記入",
		"desc1":"書類の準備と認証",
		"desc2":"Emailで申請書類を提出",
		"desc3":"コンプライアンス審査と書類への署名",
		"desc4":"口座開設完了",
		"btn":"特定投資家向け申込書",
		"btn1":"適格機関投資家向け申込書"
	},
	"fca6":{
		"title":"厳格な金融規制と高い資金安全性",
		"title-m":"厳格な金融規制と高い資金安全性",
		"desc":"英国金融行動監視機構 (FCA)",
		"desc1":"FCA口座お問い合わせ：",
		"desc2":"免責事項：本ページならびに弊社のFCAに関するコンテンツはグローバルサイトからの翻訳に留まり、特定の国や地域の居住者に対して金融サービスの提供や宣伝、勧誘を目的としていません。"
	},
	"lang":"en",
	 FCA流动性清算账户开设流程: `FCAアカウント`,
  "EBC Financial Group Limited是受英国金融市场行为管理局（FCA）授权并监管的综合金融券商":
    `EBC Financial Group (UK) Ltdは、英国金融行動監視機構（FCA）によって認可および監督されている総合な金融証券会社であり、「Matched Principal Broker」として仲介業務を行い、すべての注文は直接リクイディティプロバイダーとマッチングされます。<br/>
登録番号：927552`,
  "在EBC Financial Group Limited开设FCA流动性清算账户":
    "EBC Financial Group (UK) LtdでFCA口座を開設した場合、FSCS補償プランに基づいて最大85,000ポンドを請求する権利があります。",
  "欧盟《金融工具市场法规（MiFID）》及其后修订版MiFID": `EUの金融商品市場指令（MiFID）とその改訂版であるMiFID IIでは、顧客の知識、経験、専門性のレベルに応じて「リテール投資家」と「プロ投資家」に分類しています。`,
  根据FCA法规: `FCAの規定により、EBC Financial Group (UK) LtdにてFCA口座を開設できるのはプロ投資家（特定投資家または適格機関投資家を含む）のみとなります。レバレッジは100倍でお客様の資金はバークレイズ銀行の弊社法人口座で分別管理されます。`,
  专业投资者须满足以下三个标准中的其中两个: `プロ投資家は次の３つの基準のうち2つを満たす必要があります：`,
  "过去一年平均交易频率达到10次/季度": "過去1年間において、四半期ごとの平均取引回数が10回以上あること。",
  持有超过50万欧元的投资组合:
    "現預金やその他の金融商品の合計額が50万ユーロ以上であること。",
  在金融行业工作或至少工作过一年:
    "金融業界で1年以上の勤務経験があり、CFD（差金決済取引）や金融派生商品取引についての知識を有する者。",
  FCA流动性清算账户开户流程: `FCAアカウント`,
  获取申请表: "申請書を取得する",
  访EBC英国站: "EBC UK公式サイトで、申請書を取得してください",
  提交材料: "書類を提出",
  按要求填写: "指示に従って申請書を記入し、必要書類をアップロードしてください",
  合规审核: "コンプライアンス審査",
  等待合规审核: "コンプライアンス審査と書類への署名",
  开户成功: "FCA口座にログイン",
  登录并设置您的FCA账户: "登录并设置您的FCA账户",
  最权威的监管保护和最安全的: `厳格な金融規制と高い資金安全性`,
  "英国金融市场行为管理局（FCA）": "英国金融行動監視機構 (FCA)",
  FCA流动性清算账户咨询邮箱: `FCA口座お問い合わせ：
            <a href="mailto:support@ebcfin.co.uk">support@ebcfin.co.uk</a>
            <br/>
            免責事項：本ページならびに弊社のFCAに関するコンテンツはグローバルサイトからの翻訳に留まり、特定の国や地域の居住者に対して金融サービスの提供や宣伝、勧誘を目的としていません。`,
}

